var _rect, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnowflake1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.83543,
    height: 4.83543,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 3.90625 0.158203)",
    fill: "url(#paint0_linear_80_1874)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.707107,
    width: 3.83543,
    height: 3.83543,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 3.40625 0.36531)",
    stroke: "url(#paint1_radial_80_1874)",
    strokeOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_80_1874",
    x1: 2.41772,
    y1: 0,
    x2: 2.41772,
    y2: 4.83543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_80_1874",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.41772 0.918732) rotate(90) scale(4.3809 2.65743)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowflake1);
export default __webpack_public_path__ + "static/media/snowflake1.8c0205a144eb9180e70d9c40b11f1b62.svg";
export { ForwardRef as ReactComponent };